import { uiStore } from "@/store/store";
import { forceNextTick } from "@/util/force-next-tick";

export function toggleAndSetPanelStateToAdvanced() {
  if (!uiStore.activeElementId) return;

  const oldPanelState = { ...uiStore.panelState };

  const setPanelStateToAdvancedAdvanced = () => {
    if (!uiStore.activeElementId) return;

    uiStore.setPanelState({
      ...oldPanelState,
      elementPropertiesPanelActiveTab: {
        ...uiStore.panelState.elementPropertiesPanelActiveTab,
        [uiStore.activeElementId]: "settings"
      },
      accordionState: {
        ...uiStore.panelState.accordionState,
        elementProperties: {
          ...uiStore.panelState.accordionState.elementProperties,
          [uiStore.activeElementId]: {
            ...uiStore.panelState.accordionState.elementProperties[
              uiStore.activeElementId
            ],
            "settings.advanced": true
          }
        }
      }
    });
  };

  if (
    oldPanelState.accordionState.elementProperties[uiStore.activeElementId]?.[
      "settings.advanced"
    ] === true
  ) {
    uiStore.setPanelState({
      ...uiStore.panelState,
      accordionState: {
        ...uiStore.panelState.accordionState,
        elementProperties: {
          ...uiStore.panelState.accordionState.elementProperties,
          [uiStore.activeElementId]: {
            ...uiStore.panelState.accordionState.elementProperties[
              uiStore.activeElementId
            ],
            "settings.advanced": false
          }
        }
      }
    });

    forceNextTick(setPanelStateToAdvancedAdvanced);
  } else {
    setPanelStateToAdvancedAdvanced();
  }
}
